import { logUsage } from 'owa-analytics';
import { AttachmentState, AttachmentStateType } from 'owa-attachment-full-data';
import { refreshSharingTipsForAttachment } from 'owa-attachment-model-store';
import setAttachmentPermissionLevel from 'owa-attachment-model-store/lib/actions/setAttachmentPermissionLevel';
import { isGuestUrlPermissionLevel } from 'owa-attachment-permission';
import type { ClientAttachmentId } from 'owa-client-ids';
import AttachmentPermissionLevel from 'owa-service/lib/contract/AttachmentPermissionLevel';
import AttachmentResultCode from 'owa-service/lib/contract/AttachmentResultCode';
import type AttachmentType from 'owa-service/lib/contract/AttachmentType';
import type GetSharingInfoResponse from 'owa-service/lib/contract/GetSharingInfoResponse';
import type ReferenceAttachment from 'owa-service/lib/contract/ReferenceAttachment';

export default function handleSharingInformation(
    attachmentState: AttachmentState,
    attachment: AttachmentType,
    sharingInfoResponse: GetSharingInfoResponse
) {
    if (
        !sharingInfoResponse ||
        !(sharingInfoResponse.ResultCode === AttachmentResultCode.Success) ||
        attachmentState.attachmentType !== AttachmentStateType.Attachment
    ) {
        return;
    }

    // If the user cannot share the file we set the permission level to none. If the link is already a sharing link we
    // allow the user to resend the attachment without changing it, regardless of permissions.
    if (
        !sharingInfoResponse.CanShareInternally &&
        !isGuestUrlPermissionLevel((<ReferenceAttachment>attachment).PermissionType)
    ) {
        logUsage('AttachmentsCanNotShareInternally');
        setAttachmentPermissionLevel(attachmentState.attachmentId, AttachmentPermissionLevel.None);
    }

    refreshSharingTipsForAttachment(<ClientAttachmentId>attachment.AttachmentId);
}
